<template>
    <center v-if="maps">
    	<div class="map-infographic-container">
    		<div class="map-tab-container">
    			<div v-for="(map, i) in maps" v-bind:class="'map-tab map-' + i" v-bind:data-map="'map-' + i" v-bind:key="'map-' + i" @click="tabClick">{{map.title}}</div>
    		</div>
    		<div v-for="(map, i) in maps" class="map-infographic" v-bind:id="'map-' + i" v-bind:key="'mapinfo-' + i">
    			<img v-bind:src="map.background" class="bg">
    			<Inforgaphic4MapMarker v-for="entry in map.entries"
									v-bind:position="entry.position"
									v-bind:label="entry.label"
                                    v-bind:key="'entry'+ entry.label"/>
    		</div>
    	</div>
    </center>
</template>
<script>
import { ajaxGet, ajaxPost } from "../../../ajax";
import Inforgaphic4MapMarker from './Infographic4MapMarker'
import {apiUrl} from "@/main";
export default {
	components: { Inforgaphic4MapMarker },
    data: function (){
        return {
            maps: undefined,
            infoId: undefined
        };
    },
    created(){
        this.infoId = this.$router.history.current.params.infoId;
            var assignmentFlag = (this.$router.history.current.query.Assignment === null) ? 'assignments' : 'content';
            if(this.infoId == 'undefined') alert("Not part of assignment.");
            ajaxGet(apiUrl()+"/"+assignmentFlag+"/" + this.infoId,
            (dat) => {
                //on success dat is called
                if(dat.component == "infographic4"){
                    //This is the right component
                    this.maps = dat.data;
                    this.isAnswered = dat.answers;
                    // console.log(this.maps);
                    setTimeout(() => {this.activateMap("map-0");}, 1000);
                    window.document.title = dat.title;
                    //----------------------------------------------------------
                    if(this.$router.history.current.query.Assignment === null && !this.isAnswered){
                        ajaxPost(apiUrl() + "/assignments/" + this.infoId, {
                        Data: {
                            seen: Date.now()
                        }
                    },
                    (suc) => {
                        console.log("Posted assignment:", suc);
                    },
                    (err) => {
                        console.log("Error :", err)
                    }, localStorage.token);
                    }
                    //----------------------------------------------------------
                }else{
                    //Wrong component type
                    console.error("DATA MISMATCH on api call expected 'INFOGRAPHIC4' object, got '" + dat.component.toUpperCase() + "' object.");
                }
            },(err) => {
                //There was some error
                console.log(err);
            }, localStorage.token);
    },
    methods: {
        tabClick(e){
             var activeMap = e.srcElement.getAttribute("data-map");
             this.activateMap(activeMap);
        },
        activateMap(mapId){
            document.querySelectorAll(".map-tab").forEach(e => {
                e.classList.remove("active");
            });
            document.querySelectorAll(".map-infographic").forEach(e => {
                e.classList.remove("shown");
            });
            // console.log(document.querySelector("#" + mapId));
            document.querySelector("." + mapId).classList.add("active");
            document.querySelector("#" + mapId).classList.add("shown");
        }
    },
    mounted(){
		// document.querySelectorAll(".map-tab").forEach(e => {
		// 	e.addEventListener("click", (e) => {
	 //    		var activeMap = e.toElement.getAttribute("data-map");
	 //    		activateMap(activeMap);
	 //    		// console.log(activeMap);
	 //    	});
		// });

  //   	function activateMap(mapId){
  //   		document.querySelectorAll(".map-tab").forEach(e => {
  //   			e.classList.remove("active");
  //   		});
  //   		document.querySelectorAll(".map-infographic").forEach(e => {
  //   			e.classList.remove("shown");
  //   		});
  //   		document.querySelector("." + mapId).classList.add("active");
  //   		document.querySelector("#" + mapId).classList.add("shown");
  //   	}

  //   	activateMap("map-0");
    }
}
</script>

<style scoped>
	.map-infographic-container{
    position: relative;
    top: 55px;
    width: 800px;
    height: 600px;
    max-width: 800px;
    max-height: 600px;
    overflow: auto;
    display:flex;
    align-items: center;
    flex-direction: column;
	}
	.map-infographic-container .map-tab-container{
		display: flex;
		flex-direction: row;
		height: 50px;
	}
	.map-infographic-container .map-tab{
		height: 50px;
		color:white;
		display: flex;
		align-items: center;
		background: #00000088;
		padding: 0 1em;
		font-weight: bold;
		font-size: 1.2em;
		border-radius: 1em;
		cursor: pointer;
	}
	.map-infographic-container .map-tab.active{
		background: #fff8;
		color: black;
	}
	.map-infographic{
		width: 100%;
		height: 550px;
		display:none;
	}
	.map-infographic.shown{
		display: block;
	}
	.map-infographic > .bg{
		width: 100%;
		height: 100%;
		object-fit: fill; /*cover = clips; contain: shows full image; fill: stretches the image ignoring proportions*/
	}
</style>